import { BreadCrumbModel } from '@/models/breadcrumb';
import i18n from '@/plugins/i18n';

const Breadcrumbs = {
  home: [{
    text: i18n.t('home'),
    href: '/',
  }] as BreadCrumbModel[],

  openData: [{
    text: i18n.t('openData.title'),
    href: '/open-data',
  }] as BreadCrumbModel[],

  openDataPolicy: [{
    text: i18n.t('openDataPolicy.title'),
    href: '/policy',
  }] as BreadCrumbModel[],

  request: [{
    text: i18n.t('najizData'),
    href: '/',
  },
  {
    text: i18n.t('additionalData.title'),
    href: '/request',
  }] as BreadCrumbModel[],
};

export default Breadcrumbs;
